(function () {
const $e48dcca3c39b951a$var$photoArray = JSON.parse(document.getElementById("photos").dataset.photos);
const $e48dcca3c39b951a$var$modal = document.getElementById("modalFormGaleria");
const $e48dcca3c39b951a$var$modalViewGaleria = document.getElementById("modalViewGaleria");
const $e48dcca3c39b951a$var$modalBtnMobile = document.getElementById("modalBtn-m");
const $e48dcca3c39b951a$var$modalBtnDesktop = document.getElementById("modalBtn-d");
const $e48dcca3c39b951a$var$closeBtn = $e48dcca3c39b951a$var$modal.querySelector(".modal-close");
const $e48dcca3c39b951a$var$photosGrid = $e48dcca3c39b951a$var$modalViewGaleria.querySelector(".gridPhotos");
const $e48dcca3c39b951a$var$closeBtnViewGalery = $e48dcca3c39b951a$var$modalViewGaleria.querySelector(".modal-close");
const $e48dcca3c39b951a$var$grid = [
    {
        // eslint-disable-next-line sonarjs/no-duplicate-string
        cols: "sm:col-span-6",
        rows: "sm:row-span-6",
        ratioMin: "aspect-square",
        ratioMax: ""
    },
    {
        cols: "sm:col-span-6",
        rows: "sm:row-span-3",
        ratioMin: "aspect-square",
        ratioMax: "md:aspect-[2/1]"
    },
    {
        cols: "sm:col-span-6",
        rows: "sm:row-span-3",
        ratioMin: "aspect-square",
        ratioMax: "md:aspect-[2/1]"
    },
    {
        // eslint-disable-next-line sonarjs/no-duplicate-string
        cols: "sm:col-span-4",
        rows: "sm:row-span-4",
        ratioMin: "aspect-square",
        ratioMax: ""
    },
    {
        cols: "sm:col-span-4",
        rows: "sm:row-span-4",
        ratioMin: "aspect-square",
        ratioMax: ""
    },
    {
        cols: "sm:col-span-4",
        rows: "sm:row-span-4",
        ratioMin: "aspect-square",
        ratioMax: ""
    },
    {
        cols: "sm:col-span-4",
        rows: "sm:row-span-4",
        ratioMin: "aspect-square",
        ratioMax: ""
    },
    {
        cols: "sm:col-span-4",
        rows: "sm:row-span-4",
        ratioMin: "aspect-square",
        ratioMax: ""
    },
    {
        cols: "sm:col-span-4",
        rows: "sm:row-span-4",
        ratioMin: "aspect-square",
        ratioMax: ""
    }
];
function $e48dcca3c39b951a$var$setCookie(name, value, days) {
    const d = new Date();
    d.setTime(d.getTime() + days * 86400000);
    const expires = `expires=${d.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
}
function $e48dcca3c39b951a$var$getCookie(name) {
    const cname = `${name}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(";");
    // eslint-disable-next-line no-restricted-syntax
    for (const element of ca){
        let c = element;
        while(c.startsWith(" "))c = c.substring(1);
        if (c.startsWith(cname)) return c.substring(cname.length, c.length);
    }
    return "";
}
function $e48dcca3c39b951a$var$checkCookie(name) {
    const cookie = $e48dcca3c39b951a$var$getCookie(name);
    return cookie !== "";
}
function $e48dcca3c39b951a$var$showPhotos() {
    // Clear previous photos and display new ones
    const imageItems = document.querySelectorAll(".imageItem");
    imageItems.forEach((imageItem)=>{
        imageItem.remove();
    });
    let gridIndex = 0;
    $e48dcca3c39b951a$var$photoArray.forEach((photo)=>{
        const photoDiv = document.createElement("a");
        photoDiv.classList.add("imageItem", "w-full", "h-full", "block", "m-0", "p-0", "overflow-hidden", "col-span-1", "row-span-1", $e48dcca3c39b951a$var$grid[gridIndex].cols, $e48dcca3c39b951a$var$grid[gridIndex].rows, $e48dcca3c39b951a$var$grid[gridIndex].ratioMin);
        if ($e48dcca3c39b951a$var$grid[gridIndex].ratioMax) photoDiv.classList.add($e48dcca3c39b951a$var$grid[gridIndex].ratioMax);
        photoDiv.href = photo.Foto;
        photoDiv.setAttribute("data-fancybox", "gallery");
        photoDiv.innerHTML = `<img class="w-full h-full object-cover object-center" src="${photo.Foto}" alt="Photo">`;
        $e48dcca3c39b951a$var$photosGrid.appendChild(photoDiv);
        gridIndex = (gridIndex + 1) % $e48dcca3c39b951a$var$grid.length;
    });
    // Hide the form and show the photo container
    $e48dcca3c39b951a$var$modal.classList.remove("openModal");
    $e48dcca3c39b951a$var$modalViewGaleria.classList.add("openModal");
}
function $e48dcca3c39b951a$var$openModal() {
    const img = $e48dcca3c39b951a$var$modal.querySelector("img");
    if (img && img.dataset.src) img.setAttribute("src", img.dataset.src);
    $e48dcca3c39b951a$var$modal.classList.add("openModal");
    if ($e48dcca3c39b951a$var$checkCookie("formSubmitted")) $e48dcca3c39b951a$var$showPhotos();
}
function $e48dcca3c39b951a$var$closeModal() {
    $e48dcca3c39b951a$var$modal.classList.remove("openModal");
    $e48dcca3c39b951a$var$modalViewGaleria.classList.remove("openModal");
}
function $e48dcca3c39b951a$var$outsideClick(e) {
    if (e.target === $e48dcca3c39b951a$var$modal || e.target === $e48dcca3c39b951a$var$modalViewGaleria) $e48dcca3c39b951a$var$closeModal();
}
$e48dcca3c39b951a$var$modalBtnMobile.addEventListener("click", $e48dcca3c39b951a$var$openModal);
$e48dcca3c39b951a$var$modalBtnDesktop.addEventListener("click", $e48dcca3c39b951a$var$openModal);
$e48dcca3c39b951a$var$closeBtn.addEventListener("click", $e48dcca3c39b951a$var$closeModal);
$e48dcca3c39b951a$var$closeBtnViewGalery.addEventListener("click", $e48dcca3c39b951a$var$closeModal);
window.addEventListener("click", $e48dcca3c39b951a$var$outsideClick);
jQuery(document).ready(()=>{
    jQuery(document).on("gform_confirmation_loaded", (event, formId)=>{
        // eslint-disable-next-line camelcase,no-undef
        if (formId === Number(child_theme.gallery_form_id)) {
            $e48dcca3c39b951a$var$setCookie("formSubmitted", "true", 7); // Set cookie for 7 days
            $e48dcca3c39b951a$var$showPhotos();
        }
    });
});



})();
//# sourceMappingURL=single-property.js.map
